export const LOG_IN = 'speakeasy/login/LOG_IN';

export const LOG_IN_FAILED = 'speakeasy/login/LOG_IN_FAILD';
